export default __webpack_public_path__ + "static/media/residencial.d9875ae5.png";